import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";

@Component({
    selector: "app-tracking-details-view",
    templateUrl: "./tracking-details-view.component.html",
    styleUrls: ["./tracking-details-view.component.scss"],
})
export class TrackingDetailsViewComponent implements OnChanges {
    @Input() trackingDetails;
    @Input() notMatchedTracking;
    utilService: UtilityService;
    trackingOptions =[];

    constructor(private utilityService: UtilityService,private salesOrderService: SalesOrderService) {
        this.utilService = this.utilityService;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.trackingDetails && changes.trackingDetails.currentValue) {
            this.trackingDetails = changes.trackingDetails.currentValue;
        }
        this.salesOrderService.loadTrackingOptions().pipe().subscribe((options) => {
            this.trackingOptions = options;
        });
    }


    replaceCommaLine(data) {
        let dataToArray = data.split(",").map((item) => item.trim());
        return dataToArray;
    }
}
